import React from 'react';
import PropTypes from 'prop-types';

import './ContentTitle.scss';

export default class ContentTitle extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
            .isRequired,
    };

    static defaultProps = {};

    render() {
        return (
            <div
                className={`component-Elements-ContentTitle ${this.props.className}`}
            >
                {this.props.children}
            </div>
        );
    }
}
